class HandleLocalData {
  /**
   * for handling data that was received for unique user
   */
  prepareAndStoreUserData(serverData) {
    const userID = localStorage.getItem('userHash');
    const localData = JSON.parse(localStorage.getItem(userID)) ?? {};
    const userProfileExistingData = localData?.userProfileData ?? null;
    const workoutSetupExistingData = localData?.workoutFeedbackData ?? null;
    const waterBalanceExistingData = localData?.waterBalanceData ?? null;

    const userProfileData = {
      userGender: serverData.userProfileData.userGender,
      userName: serverData.userProfileData.userName,
      userWeight: serverData.userProfileData.userWeight,
    };

    if (userProfileExistingData === null && userProfileData) {
      localData["userProfileData"] = userProfileData;
      localStorage.setItem(userID, JSON.stringify(localData));
    }

    const workoutFeedbackData = serverData.workoutFeedbackData.map((item) => {
      return {
        date: item.date,
        "user-data": {
          difficultyExercise: item["user-data"].map(item => item.difficultyExercise)[0],
          exerciseNameLocal: item["user-data"].map(item => item.exerciseNameLocal)[0],
          exerciseName: item["user-data"].map(item => item.exerciseName)[0],
          feelingEstimation: item["user-data"].map(item => item.feelingEstimation)[0],
          heartBeatsEstimation: item["user-data"].map(item => item.heartBeatsEstimation)[0],
          isRecordedUserResponse: !!item["user-data"].map(item => item.isRecordedUserResponse)[0],
          workoutEstimation: item["user-data"].map(item => item.workoutEstimation)[0],
        },
      };
    });

    if (workoutSetupExistingData === null || workoutFeedbackData.length > 0) {
      localData["workoutFeedbackData"] = workoutFeedbackData;
      localStorage.setItem(userID, JSON.stringify(localData));
    }

    let waterBalanceData = serverData.waterBalanceData.map((item) => {
      return {
        date: item.date,
        lactoseFreeDays: item.lactoseFreeDays,
        lactoseFreeDaysAutocompleted: Boolean(item.lactoseFreeDaysAutocompleted),
        lactoseFreeDaysChallengeProgressType: Boolean(item.lactoseFreeDaysChallengeProgressType),
        lactoseFreeDaysStatus: Boolean(item.lactoseFreeDaysStatus),
        lactoseFreeDaysStatusDaily: item.lactoseFreeDaysStatusDaily,
        noSugarDays: item.noSugarDays,
        noSugarDaysAutocompleted: Boolean(item.noSugarDaysAutocompleted),
        noSugarDaysChallengeProgressType: Boolean(item.noSugarDaysChallengeProgressType),
        noSugarDaysStatus: Boolean(item.noSugarDaysStatus),
        noSugarDaysStatusDaily: item.noSugarDaysStatusDaily,
        soberDays: item.soberDays,
        soberDaysAutocompleted: Boolean(item.soberDaysAutocompleted),
        soberDaysChallengeProgressType: Boolean(item.soberDaysChallengeProgressType),
        soberDaysStatus: Boolean(item.soberDaysStatus),
        soberDaysStatusDaily: item.soberDaysStatusDaily,
        waterAmount: item.waterAmount,
      };
    }).sort((a, b) => a.date.localeCompare(b.date));

    if (waterBalanceData.length > 0) {
      // const waterBalanceLastItem = waterBalanceData.at(-1);
      const waterBalanceLastItem = waterBalanceData.find(item => {
        return item.date === new Date().toISOString().split('T')[0];
      }) ?? waterBalanceData.at(-1);

      console.log(waterBalanceData)
      console.log(waterBalanceLastItem)

      if (waterBalanceLastItem) {
        localStorage.setItem('challengeNullishValue', JSON.stringify(
          {
            'lactoseFreeDaysStatus': waterBalanceLastItem.lactoseFreeDaysStatus,
            'noSugarDaysStatus': waterBalanceLastItem.noSugarDaysStatus,
            'soberDaysStatus': waterBalanceLastItem.soberDaysStatus,
          }));
        localStorage.setItem('challengeStatus', JSON.stringify(
          {
            'lactoseFreeDaysStatusDaily': waterBalanceLastItem.lactoseFreeDaysStatusDaily,
            'noSugarDaysStatusDaily': waterBalanceLastItem.noSugarDaysStatusDaily,
            'soberDaysStatusDaily': waterBalanceLastItem.soberDaysStatusDaily,
          }));
        localStorage.setItem('isBegun', JSON.stringify(
          {
            'lactoseFreeDaysAutocompleted': waterBalanceLastItem.lactoseFreeDaysAutocompleted,
            'noSugarDaysAutocompleted': waterBalanceLastItem.noSugarDaysAutocompleted,
            'soberDaysAutocompleted': waterBalanceLastItem.soberDaysAutocompleted,
          }));
        localStorage.setItem('challengeAutoUpdating', JSON.stringify(
          {
            'lactoseFreeDaysChallengeProgressType': waterBalanceLastItem.lactoseFreeDaysChallengeProgressType,
            'noSugarDaysChallengeProgressType': waterBalanceLastItem.noSugarDaysChallengeProgressType,
            'soberDaysChallengeProgressType': waterBalanceLastItem.soberDaysChallengeProgressType,
          }));
        localStorage.setItem('autocomplete_challenges', JSON.stringify(
          {
            'lactoseFreeDaysAutocompleted': waterBalanceLastItem.lactoseFreeDaysStatus,
            'noSugarDaysAutocompleted': waterBalanceLastItem.noSugarDaysStatus,
            'soberDaysAutocompleted': waterBalanceLastItem.soberDaysStatus,
          }));
      }
    } else {
      localStorage.setItem('challengeNullishValue', JSON.stringify(
        {
          'lactoseFreeDaysStatus': false,
          'noSugarDaysStatus': false,
          'soberDaysStatus': false,
        }));
      localStorage.setItem('challengeStatus', JSON.stringify(
        {
          'lactoseFreeDaysStatusDaily': '1970-01-01',
          'noSugarDaysStatusDaily': '1970-01-01',
          'soberDaysStatusDaily': '1970-01-01',
        }));
      localStorage.setItem('isBegun', JSON.stringify(
        {
          'lactoseFreeDaysAutocompleted': false,
          'noSugarDaysAutocompleted': false,
          'soberDaysAutocompleted': false,
        }));
      localStorage.setItem('challengeAutoUpdating', JSON.stringify(
        {
          'lactoseFreeDaysChallengeProgressType': false,
          'noSugarDaysChallengeProgressType': false,
          'soberDaysChallengeProgressType': false,
        }));
      localStorage.setItem('autocomplete_challenges', JSON.stringify(
        {
          'lactoseFreeDaysAutocompleted': false,
          'noSugarDaysAutocompleted': false,
          'soberDaysAutocompleted': false,
        }));
    }

    if (waterBalanceExistingData === null || waterBalanceData.length > 0) {
      console.log(waterBalanceData)
      localData["waterBalanceData"] = [...waterBalanceData];
      localStorage.setItem(userID, JSON.stringify(localData));
    }
  }
}

export default new HandleLocalData();